import {css, FlattenSimpleInterpolation} from 'styled-components'
import {ButtonProps} from '@miro-site/core'
import FocusTrap from '../../focus-trap/FocusTrap'

const getArrowDirectionCSS = (props: ButtonProps): FlattenSimpleInterpolation => {
  if (!props.$withArrow) {
    return []
  }

  /**
   * Used for hiding the arrow when the button has been clicked and
   * is showing the loading spinner.
   */
  const loadingStateStyles = props.isLoading
    ? `
  visibility: hidden;
`
    : ''

  if (props.$arrowDirection) {
    return css`
      ${FocusTrap}:after {
        content: ' ${props.$arrowDirection}';
        pointer-events: none;
        ${loadingStateStyles}
      }
    `
  }

  return css`
    ${FocusTrap}:after {
      content: ' \\2192';
      pointer-events: none;
      ${loadingStateStyles}
    }

    // Flipping arrow to left ← for RTL languages
    [dir='rtl'] && ${FocusTrap}:after {
      content: ' \\2190';
      pointer-events: none;
      ${loadingStateStyles}
    }
  `
}

export default getArrowDirectionCSS
